import type { Bindings } from 'alpinejs'

import { $slider, type WithSlider } from '../SliderCTX'

export const nextButton: ThisType<WithSlider> & Bindings<Button> = {
  [':disabled']() {
    return this[$slider].isLast
  },
  'x-on:click'() {
    this[$slider].next()
  },
}

export const prevButton: ThisType<WithSlider> & Bindings<Button> = {
  [':disabled']() {
    return this[$slider].isFirst
  },
  'x-on:click'() {
    this[$slider].prev()
  },
}

export const goTo = (idx: number): ThisType<WithSlider> & Bindings<Button> => ({
  [':disabled']() {
    return this[$slider].focusedIndex === idx
  },
  'x-on:click'() {
    this[$slider].scrollTo(idx)
  },
})

export type Button = {
  ':disabled'(): boolean
  'x-on:click'(): void
}
